import React, { SVGProps } from "react";

export default function SupXCircle(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M14.2999 14.997L9.99873 10.7063L5.6964 14.9971L4.98926 14.29L9.29074 9.99997L4.98982 5.70943L5.69695 5.00229L9.99882 9.29378L14.2985 5.00552L15.0057 5.71266L10.7068 10.0001L15.007 14.2899L14.2999 14.997Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM17.2 10C17.2 13.9765 13.9765 17.2 10 17.2C6.02355 17.2 2.8 13.9765 2.8 10C2.8 6.02355 6.02355 2.8 10 2.8C13.9765 2.8 17.2 6.02355 17.2 10Z"
        fill="currentColor"
      />
    </svg>
  );
}
